import { render, staticRenderFns } from "./Moda.vue?vue&type=template&id=7756836c&"
import script from "./Moda.vue?vue&type=script&lang=js&"
export * from "./Moda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports